import { Link } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";
import Agenda from "../../Agenda";
import DropdownMenuIcon from "../DropdownMenuIcon";

interface IMinhaAgendaProps {
    iconColor?: string;
}

export default function MinhaAgenda(props: IMinhaAgendaProps) {
    return (
        <DropdownMenuIcon
            icon={
                <i
                    className="far fa-calendar"
                    style={{ color: props.iconColor }}
                />
            }
            offset={45}
        >
            <div
                className={`d-flex flex-column pt-12 rounded-top`}
                style={{ backgroundColor: `var(--capys)` }}
            >
                <h4 className="d-flex flex-center rounded-top">
                    <span className="text-white">Minha Agenda</span>
                </h4>
            </div>
            <div
                className="p-5 y-scroll"
                style={{
                    height: "325px",
                }}
            >
                <div className="w-100 mt-1 mb-5 text-center">
                    <Link to={ACESSOS.GERAL.TELAS.AGENDA.DS_PATH}>
                        Agenda Completa
                    </Link>
                </div>
                <Agenda flApenasAgendamentosDoUsuario responsivo={true} />
            </div>
        </DropdownMenuIcon>
    );
}
